import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }}><path d="M3.615 7.229A3.614 3.614 0 113.613 0a3.614 3.614 0 01.002 7.229zm0-.657a2.957 2.957 0 100-5.915 2.957 2.957 0 000 5.915z" /><path d="M4.698 4.315a.295.295 0 01-.417.417l-.885-.885a.295.295 0 01-.086-.209V1.869a.295.295 0 11.59 0v1.647l.798.799z" /></svg>;
}
export default SvgComponent;